<template>
	<div class="md-layout upload-group">
		<div class="md-layout-item">
			<md-card>
				<md-card-header class="md-card-header-icon text_center">
					<h3>{{ $t("seller.marketSounding.excelUpload.title") }}</h3>
				</md-card-header>
				<md-card-content>
					<div class="flex flex_column flex_between">
						<div class="card_content_head">
							<div class="xml_excel_upload">
								<h4 class="text_center">{{ $t("seller.marketSounding.excelUpload.step1") }}</h4>
								<div class="icon_tip" style="margin-left:15px; margin-top:0; height:225px">
									<md-field class="margin_top w_33" style="min-width: 260px">
										<label class="font_base" style="font-size: 12px">
											{{ $t("seller.marketSounding.start.card.documentsAvailable") }}*
										</label>
										<TbSelect v-model="form.documentAvailable"
												  :search-allow="false"
												  :options="yesOrNoOptions"
												  options-value-field="value"
												  options-display-field="displayValue"
										/>
									</md-field>
									<AssignmentTypeSelect class="w_33" style="min-width: 260px"
										v-model="form.disclosed"
										:required="true"
									></AssignmentTypeSelect>
									<RetentionCheck
										v-model="form.sellWithRetention"
										:debtor-id="null"
										:validation-rules="modelValidations.sellWithRetention"
										:validator="$validator"
										:is-multiple="true"
									/>
									<NoSanctionsCheck
										v-model="form.noSanctionsConfirmation"
										:validation-rules="modelValidations.noSanctionsConfirmation"
										:validator="$validator"
										:is-multiple="true"
									/>
								</div>

								<div v-if="excelUploadPossible">
									<h4 class="text_center font_bold" style="margin-top: 20px;">
										{{ $t("seller.marketSounding.excelUpload.step2") }}
										<a class="font_base font_weight_normal" :href="excelUrl" target="_blank">
											({{ $t("common.template") }})
										</a>
									</h4>
									<div>
										<FileInputUpload
											v-on:isUploaded="onUploadSuccess"
											:isProspective="true"
											:checkDocumentFileName="form.documentAvailable"
											:isDisclosed="form.disclosed"
										></FileInputUpload>
										<div style="margin-top: 15px; margin-left: 15px;">

										</div>
									</div>
								</div>
							</div>
						</div>

						<div  v-if="excelUploadPossible">
							<h3 v-if="videoUploadPercent == 0" class="inactive_color"></h3>
							<h3 class="accent_color" v-if="videoUploadPercent > 0">
								{{ $t("seller.upload.cardlist.Uploading") }}
								{{ videoUploadPercent + "%" }}
								{{ $t("seller.upload.cardlist.Documents") }}
							</h3>

							<div v-if="shouldShowDocumentUpload" class="card_content_head" style="margin-top: 10px;">
								<h4 class="text_center font_bold">{{ $t("seller.marketSounding.excelUpload.step3") }}</h4>
								<div style="margin:1rem">
									<FileUpload
										v-on:chageFile="changeFile"
										:filUrl="form.url"
										v-on:changePercent="changePercent"
										:disable="isLoading"
										iconName="fa-file-text"
										accept="pdf"
										:loadApi="'uploadDocuments'"
									></FileUpload>
									<p class="paf_tip text_center">
										{{ $t("seller.marketSounding.excelUpload.batchDocument.tip") }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>
<script>
import FileUpload from "@/components/templates/FileUpload.vue";
import FileInputUpload from "../FileInputUpload.vue";
import enumStatus from "@/common/enum";
import APP from "@/common/appConfig";
import {localization} from "@/common/lang/localization";
import {isValueSet} from "@/common/format";
import NoSanctionsCheck from "@/components/templates/seller/NoSanctionsCheck.vue";
import AssignmentTypeSelect from "@/components/templates/select/AssignmentTypeSelect.vue";
import RetentionCheck from "@/components/templates/seller/RetentionCheck.vue";
import {validateRequiredFields} from "@/validation/validation";

export default {
	components: {
		RetentionCheck, AssignmentTypeSelect, NoSanctionsCheck,
		FileUpload,
		FileInputUpload
	},
	data() {
		let defaultForm = {
			url: "",
			documentAvailable: null,
			disclosed: this.$sessionStorage.get("localeUser").auctionDisclosed,
			noSanctionsConfirmation: false,
			sellWithRetention: false
		};
		return {
			form: { ...defaultForm },
			videoUploadPercent: 0,
			isLoading: false,
			excelUrl: `${APP.DOMAIN}static/xls/Walbing-import-MS-${localization.currentLocale()}-2.0.xlsx`,
			isUploaded: false,
			yesOrNoOptions: [
				{ value: true, displayValue: this.$t("common.yes") },
				{ value: false, displayValue: this.$t("common.no") },
			],
			modelValidations: {
				noSanctionsConfirmation: {
					checked: true
				},
				sellWithRetention: {
					checked: true
				},
				disclosed: {
					required: true
				}
			},
		};
	},
	methods: {
		isValueSet,
		onUploadSuccess(successful) {
			this.isUploaded = successful;
		},
		changeFile(data) {
		},

		changePercent(data) {
			this.isLoading = true;
			this.videoUploadPercent = data.uploadPercent;
			if (data.uploadPercent >= 100) {
				setTimeout(() => {
					this.$emit("uploaded");
					this.videoUploadPercent = 0;
					this.isLoading = false;
				}, 500);
			}
		}
	},
	computed: {
		excelUploadPossible() {
			return validateRequiredFields(this.form, this.modelValidations);
		},
		shouldShowDocumentUpload() {
			return this.isUploaded && this.form.documentAvailable
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../upload";
</style>
